/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { ReactElement, useEffect, useState } from 'react';
import './MatchedVisasDashboard-Mobile-experiment-1.scss';

type MatchedVisasItemProps = {
    countryVisaData: any;
    isAssessmentScoreEmpty?: boolean;
    paid: boolean;
};

function MatchedVisasItemMobileExperiment1({
    countryVisaData,
    isAssessmentScoreEmpty,
    paid,
}: MatchedVisasItemProps): ReactElement | null {
    const initialWidth = () => {
        if (window.innerWidth <= 767) {
            return '30';
        }
        if (window.innerWidth > 767 && window.innerWidth <= 1028) {
            return '35';
        }
        if (window.innerWidth > 1028) {
            return '40';
        }
    };
    const initialHeight = () => {
        if (window.innerWidth <= 767) {
            return '20';
        }
        if (window.innerWidth > 767 && window.innerWidth <= 1028) {
            return '25';
        }
        if (window.innerWidth > 1028) {
            return '30';
        }
    };
    const [isNumberThere, setIsNumberThere] = useState<boolean>(false);
    const [, setWidth] = useState(initialWidth());
    const [, setHeight] = useState(initialHeight());

    const trueScore = (item: any): number => {
        const score: number = Math.round((100 * item.summary.score) / item.summary.max_score);

        if (isNaN(score)) {
            return 70;
        }
        return score;
    };
    const scoreLevel = (score: number) =>
        score < 50 ? 'lowScore' : score < 71 ? 'mediumScore' : 'highScore';

    const sortedItems = [...countryVisaData.eligible_programs].sort((a, b) => {
        if (trueScore(a) < trueScore(b)) {
            return 1;
        } else if (trueScore(a) > trueScore(b)) {
            return -1;
        } else {
            return 0;
        }
    });

    useEffect(() => {
        const score = trueScore(sortedItems[0]);
        setIsNumberThere(score !== Infinity);
    }, [sortedItems]);

    useEffect(() => {
        const score = trueScore(sortedItems[0]);
        setIsNumberThere(score !== Infinity);
    }, [sortedItems]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 767) {
                setWidth('30');
                setHeight('20');
            }
            if (window.innerWidth > 767 && window.innerWidth <= 1028) {
                setWidth('35');
                setHeight('25');
            }
            if (window.innerWidth > 1028) {
                setWidth('40');
                setHeight('30');
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getMoreItems = (sortedItems: any) => {
        let items = 0;
        if (sortedItems.length > 2) {
            items = sortedItems.length - 2;
        }
        return items;
    };

    const getImage = (item: any) => {
        let image = '';

        switch (item.visa_type) {
            case 'Business':
                image = '/purpose_icon_2.png';
                break;
            case 'Work':
                image = '/purpose_icon_5.png';
                break;
            case 'Travel':
                image = '/purpose_icon_3.png';
                break;
            case 'Study':
                image = '/purpose_icon_4.png';
                break;

            default:
                image = '/purpose_icon_1.png';
        }

        return image;
    };

    return (
        <div className={'MatchedVisasItemWrapperE1'}>
            <div className={'countryWrapperMobileE1'}>
                <div className={'countryNameE1'}>
                    Programs you are eligible for in{' '}
                    <span className={'country'}>{countryVisaData.country} </span>
                    {countryVisaData.country === 'Canada' ? '🇨🇦' : '🇦🇺'}
                </div>
            </div>
            <div className="MatchedVisasItemResultsE1">
                {sortedItems.slice(0, 2).map((item: any, index: number) => (
                    <div className="MatchedVisasItemResultE1" key={index}>
                        <div className="visaResultBodyE1">
                            <img
                                style={{ width: '2rem' }}
                                src={process.env.PUBLIC_URL + getImage(item)}
                                alt="purpose icon"
                            />

                            <div className="visaResultTextE1">
                                {item.visa_type} <br />
                                Visa
                            </div>
                            <div
                                className={`visaResultScore ${scoreLevel(trueScore(item))}`}
                                style={{ filter: isNumberThere && paid ? 'none' : 'blur(6px)' }}
                            >
                                {`${trueScore(item)}%`}
                            </div>
                        </div>
                    </div>
                ))}
                <div className={getMoreItems(sortedItems) ? 'MoreItems' : 'NoMoreItems'}>
                    + {getMoreItems(sortedItems)} More
                </div>
            </div>

            <p className="InfoParagraph">
                Reveal your chances of success by getting an expert consultation.
            </p>
        </div>
    );
}

export default MatchedVisasItemMobileExperiment1;
